/* eslint-disable comma-dangle */

export default {
    address: [
        'user-input',
        'map',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'rooms-for-rent-count-daily',
        'room-area',
        'beds-count',
        'all-rooms-area',
        'floor',
        'rooms-for-rent-total-count',
        'kitchen-area',
        'visual-divider',
        'loggias-count',
        'balconies-count',
        'visual-divider',
        'separate-wcs-count',
        'combined-wcs-count',
        'visual-divider',
        'repair-type',
        'in-flat-rent'
    ],
    'about-building': [
        'name-and-year',
        'material-type-and-series',
        'ceiling-height',
        'passenger-lifts',
        'cargo-lifts',
        'in-house',
        'parking'
    ],
    'price-and-deal-terms': [
        'price-rent-daily',
        'bargain-daily',
        'deposit',
        'self-employed',
        'tenants-type'
    ]
};
